var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLvt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 76,
    viewBox: "0 0 173 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1253 42.655H36.1383V44.975H27.6953V30.209H30.1253V42.655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.415 44.973L35.2891 30.206H37.946L41.8701 42.04L45.8151 30.206H48.452L43.326 44.973H40.415Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.633 30.209V32.529H55.478V44.973H53.052V32.529H48.875V30.209H59.633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6814 45.249C72.5134 45.2484 71.361 44.9807 70.3123 44.4662C69.2637 43.9517 68.3467 43.2042 67.6314 42.2808C66.9161 41.3574 66.4214 40.2827 66.1854 39.1387C65.9493 37.9948 65.978 36.812 66.2694 35.6809C66.5607 34.5498 67.107 33.5003 67.8663 32.6127C68.6256 31.7252 69.5778 31.023 70.6502 30.5601C71.7226 30.0972 72.8867 29.8857 74.0534 29.9418C75.2201 29.998 76.3584 30.3203 77.3814 30.884C78.4814 31.4852 79.3969 32.3747 80.0294 33.457L77.9204 34.68C77.5252 33.9479 76.9287 33.3441 76.2014 32.94C75.4326 32.507 74.5628 32.2851 73.6804 32.297C72.9732 32.2687 72.2677 32.3874 71.6087 32.6456C70.9496 32.9038 70.3512 33.2958 69.8514 33.797C68.9082 34.8367 68.3857 36.1902 68.3857 37.594C68.3857 38.9978 68.9082 40.3513 69.8514 41.391C70.3512 41.8923 70.9495 42.2844 71.6086 42.5426C72.2677 42.8008 72.9732 42.9194 73.6804 42.891C74.5658 42.9019 75.4386 42.6802 76.2114 42.248C76.9408 41.8495 77.5356 41.2437 77.9204 40.507L80.0294 41.707C79.4074 42.793 78.4985 43.687 77.4024 44.291C76.2674 44.9307 74.9842 45.2611 73.6814 45.249Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5505 44.973L90.5165 41.998H84.2305L83.1976 44.973H80.5605L85.9186 30.206H88.8295L94.1666 44.973H91.5505ZM85.0316 39.72H89.7145L87.3735 33.054L85.0316 39.72Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.191 30.209C101.837 30.1917 102.48 30.3063 103.08 30.5457C103.68 30.785 104.225 31.1441 104.682 31.601C105.582 32.526 106.085 33.7653 106.085 35.0555C106.085 36.3457 105.582 37.5851 104.682 38.51C104.227 38.9693 103.682 39.3305 103.081 39.5712C102.481 39.812 101.838 39.9273 101.191 39.91H98.175V44.973H95.749V30.209H101.191ZM101.191 37.634C101.521 37.6441 101.849 37.5847 102.154 37.4594C102.46 37.3341 102.735 37.1459 102.963 36.907C103.412 36.3969 103.66 35.7406 103.66 35.061C103.66 34.3814 103.412 33.7252 102.963 33.215C102.736 32.9758 102.46 32.7873 102.155 32.6618C101.849 32.5364 101.521 32.4768 101.191 32.487H98.175V37.634H101.191Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.194 30.209H110.62V44.973H108.194V30.209Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.172 30.209V32.529H119.016V44.973H116.59V32.529H112.413V30.209H123.172Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.53 44.973L132.496 41.998H126.21L125.176 44.973H122.539L127.897 30.206H130.808L136.146 44.973H133.53ZM127.011 39.72H131.694L129.353 33.054L127.011 39.72Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.154 42.655H146.166V44.975H137.728V30.209H140.154V42.655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.258 51.953H19V24H153.258V51.953ZM20.158 50.797H152.102V25.156H20.156L20.158 50.797Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 134.257,
    height: 27.953,
    fill: "white",
    transform: "translate(19 24)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLvt);
export default __webpack_public_path__ + "static/media/lvt.efc24b7ac6c3c80e4d7bb484221436d0.svg";
export { ForwardRef as ReactComponent };